// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-application--wrap[data-v-0a29a003]{margin-top:env(safe-area-inset-top)}.v-app-bar[data-v-0a29a003]{margin-top:env(safe-area-inset-top)!important}.v-navigation-drawer__content[data-v-0a29a003]{padding-top:env(safe-area-inset-top)}.v-navigation-drawer__content [role=separator]+[role=separator][data-v-0a29a003]{visibility:hidden}", ""]);
// Exports
module.exports = exports;
